import ToggleButton from '../../../components/common/toggle-button';
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import AccordionTile from '../Accordion';
import {
  PackageProduct,
  ProductTemplateKey,
  ProductTemplate,
  useCreatePackageProduct,
  useUpdatePackageProduct,
} from '../../../hooks/useClients';
import { Package } from '../../../hooks/useClients';

type props = {
  client: any;
  data: any;
  default: any;
  UpdateSaveOption: (data: boolean) => void;
};

interface UnlimitedAccessProps {
  packageData: Package;
  defaultTemplate: ProductTemplate;
  setSaveDataModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const UnlimitedAcess: React.FunctionComponent<UnlimitedAccessProps> = ({
  packageData,
  defaultTemplate,
  setSaveDataModal,
}): JSX.Element => {
  const selectedPackageProduct = packageData.package_products.find(
    (item: PackageProduct) => item.product.key === ProductTemplateKey.UNLIMITED_ACCESS,
  );
  const { createPackageProduct } = useCreatePackageProduct(
    packageData.client_id!,
    selectedPackageProduct?.package_id! || packageData.id!,
    defaultTemplate.id,
  );
  const { updatePackageProduct } = useUpdatePackageProduct(packageData.client_id!, selectedPackageProduct?.id!);

  const [isCallUnit, setisCallUnit] = useState(false);
  const [unlimitedAccess, setunlimitedAccess] = useState(false);
  const [reservedBalance, setReservedBalance] = useState(0);
  const [enableSaveOption, setenableSaveOption] = useState(false);
  const [hidePayment, sethidePayment] = useState(false);

  useEffect(() => {
    if (packageData) {
      if (selectedPackageProduct) {
        setisCallUnit(selectedPackageProduct.configuration?.is_call_units || false);
        setunlimitedAccess(selectedPackageProduct?.status === 'enabled' ? true : false);
        const configuration = selectedPackageProduct.configuration;
        sethidePayment(configuration?.hide_payment_tiles || false);
        setReservedBalance(selectedPackageProduct.unused_minute_balance);
      } else {
        setunlimitedAccess(false);
        const configuration = defaultTemplate.configuration;
        sethidePayment(configuration?.hide_payment_tiles || false);
        setReservedBalance(0);
      }
      setenableSaveOption(false);
    }
  }, [packageData]); // eslint-disable-line react-hooks/exhaustive-deps

  const onSave = () => {
    const payload: Partial<PackageProduct> = {
      status: unlimitedAccess ? 'enabled' : 'disabled',
      configuration: {
        hide_payment_tiles: hidePayment,
        is_call_units: isCallUnit,
      },
    };
    if (selectedPackageProduct) {
      updatePackageProduct.mutate(payload);
    } else {
      createPackageProduct.mutate(payload);
    }
  };

  useEffect(() => {
    setSaveDataModal(enableSaveOption);
  }, [enableSaveOption]);

  return (
    <>
      <AccordionTile
        setStatus={(data: boolean) => {
          !enableSaveOption && setenableSaveOption(true);
          setunlimitedAccess(data);
        }}
        Label={'UNLIMITED ACCESS'}
        status={unlimitedAccess}
        id={'UnlimitedAcess'}
        buttonText={'SAVE'}
        initialstatus={true}
        disableButton={enableSaveOption}
        onButtonClick={() => {
          if (enableSaveOption) onSave();
        }}
        InnerComponent={
          <div>
            <div className="flex w-full justify-start pt-2">
              <div className="flex w-1/3 items-center px-2">
                <p className="text-blue-dark text-sm font-medium">Reserved Balance: {reservedBalance} minutes</p>
              </div>
              <div className="flex w-1/3 items-center">
                <p className="text-blue-dark px-4 text-sm font-medium">Hide Payment Setup Requests</p>
                <ToggleButton
                  setStatus={(data) => {
                    !enableSaveOption && setenableSaveOption(true);
                    sethidePayment(data);
                  }}
                  status={hidePayment}
                  id={'hidepaymentStatus'}
                  initialstatus={true}
                />
                <p className="text-blue-dark px-4 text-sm font-medium">Using Call Units</p>
                <ToggleButton
                  setStatus={(data) => {
                    !enableSaveOption && setenableSaveOption(true);
                    setisCallUnit(data);
                  }}
                  status={isCallUnit}
                  id={'is_call_unit'}
                  initialstatus={false}
                />
              </div>
            </div>
            {!selectedPackageProduct?.product_id && (
              <p className="text-blue-dark mb-2 block pt-2 text-sm font-medium leading-4">
                You must save this product to add credit
              </p>
            )}
          </div>
        }
      />
    </>
  );
};

export default UnlimitedAcess;
